import { LOGOUT, SET_MEALS_LIST } from "../actions/types";

const INITIAL_STATE = {
    list: []
};

const mealReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_MEALS_LIST:
            return {
                ...state,
                list: action.payload.map(meal => {
                    return {
                        mealID: meal.mealID,
                        code: meal.code,
                        description: meal.description,
                        category: meal.category
                    };
                })
            };
        case LOGOUT:
            return INITIAL_STATE;
        default:
            return state;
    }
};

export default mealReducer;